import { min, max } from 'd3-array';

import Indicator from '../Indicator';
import LineMarker from '../markers/LineMarker';

/** P/E Range indicator */
export default class PERangeIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 */
	_getDefaultParams() {
		return {
			id: 'perange',
			name: 'P/E Range',
			dataSeries: 'perangeupper',
			description: 'P/E Range shows the high and low P/E for the period.',
			inputs: [{ name: 'earningstype', value: 0 }],
			componentSeries: [
				{ id: 'perangeupper' },
				{ id: 'perangelower', styleRef: 'low' }
			]
		};
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range minimum
	 */
	getRangeMin(data) {
		return min(data.perange || [], i => +i.perangelower);
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range maximum
	 */
	getRangeMax(data) {
		return max(data.perange || [], i => +i.perangeupper);
	}

	/**
	 * @return {object}
	 * @property {LineMarker} line
	 * @property {LineMarker} lineLow
	 */
	_getMarkers() {
		return {
			line: new LineMarker(),
			lineLow: new LineMarker()
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {

		this._renderLineMarker({
			data: data[this.params.id],
			dataKey: 'perangeupper',
			sessionType
		});

		this._renderLineMarker({
			data: data[this.params.id],
			dataKey: 'perangelower',
			marker: this.markers.lineLow,
			sessionType,
			styleKey: 'low'
		});
	}
}
